import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  background-color: ${(props) => props.theme.colors.custom.white};
  border-radius: ${(props) => props.theme.border_radius.card};
  box-shadow: ${(props) => props.theme.box_shadow.card};
  gap: ${(props) => props.theme.spacing['2']};
`
